/**
 * @file tag.component.tsx
 * @description Компонент обертка для работы с @consta.uikit/Tag.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { Tag as ConstaTag } from '@consta/uikit/Tag';
import React from 'react';

/**
 * Props для компонента Tag
 */
interface ITagProps {
    /** Заголовок тега */
    title: string;
    /** Обработчик закрытия тега */
    onTagClose?: () => void;
    /** Обработчик клика по тегу */
    onClick?: (event: React.MouseEventHandler<HTMLButtonElement>) => void;
    /** Режим отображения тега */
    mode?: 'button' | 'link';
}

export const Tag = ({ title, onTagClose, onClick, mode = 'link', ...props }: ITagProps) => {
    if (mode === 'button') {
        return (
            <ConstaTag
                label={title}
                mode="button"
                onClick={onClick as any}
                size="xs"
                {...props}
            />
        );
    }
    
    return (
        <ConstaTag
            label={title}
            mode="link"
            onClick={onClick as any}
            size="xs"
            {...props}
        />
    );
};
